// src/components/chat-bot/ToggleButton.js
import PropTypes from 'prop-types';
import { useTheme, alpha } from '@mui/material/styles';
import { Tooltip, Box, Badge,Avatar } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import IconButtonAnimate from './IconButtonAnimate';
import BotIcon from '../Assets/Icon/kissanIcon.png'
// ----------------------------------------------------------------------

ToggleButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  showBadge: PropTypes.bool.isRequired,
};

export default function ToggleButton({ onClick, showBadge }) {
  const theme = useTheme();

  // A helper function to replicate the old `bgBlur` utility
  const bgBlur = (props) => {
    const color = props?.color || theme.palette.background.default;
    const blur = props?.blur || 6;
    const opacity = props?.opacity || 0.8;
    return {
      backdropFilter: `blur(${blur}px)`,
      WebkitBackdropFilter: `blur(${blur}px)`, // For Safari
      backgroundColor: alpha(color, opacity),
    };
  };


  const ChatIconButton = (
    <Tooltip title="Chatbot">
      <span>
        
          <Avatar
            sx={{

              padding: '4px',
            }}
          >
            <img
              src={BotIcon}
              alt="Chatbot Icon"
              style={{
                height: 58,
                width: 58,
                objectFit: 'contain',



              }}
            />
          </Avatar>
        
      </span>
    </Tooltip>
  );

  return (
    <Box
      sx={{
        p: 0.5,
        right: 24,
        bottom: 50,
        zIndex: 9998,
        position: 'fixed',
        borderRadius: '50%',
        boxShadow: `-12px 12px 32px -4px ${alpha(
          theme.palette.mode === 'light' ? theme.palette.grey[600] : theme.palette.common.black,
          0.36
        )}`,
        ...bgBlur({ color: theme.palette.background.default }),
      }}
      onClick={onClick}
    >
      {showBadge ? (
        <Badge
          variant="dot"
          color="error"
          sx={{
            '& .MuiBadge-badge': {
              top: 4,
              right: 4,
              transformOrigin: 'center',
              animation: 'pulse 1.2s infinite',
            },
            '@keyframes pulse': {
              '0%': { transform: 'scale(1)' },
              '50%': { transform: 'scale(1.5)' },
              '100%': { transform: 'scale(1)' },
            },
          }}
        >
          {ChatIconButton}
        </Badge>
      ) : (
        ChatIconButton
      )}
    </Box>
  );
}